<template>
  <Loader :value="promises.fetch" class="settings-webhooks-loader">
    <Paywall
      :value="$store.getters.isSuperadmin ? [false] : $store.state.addons"
      :items="$store.getters.isSuperadmin ? [false] : 'api'"
    >
      <template #content>
        <Pricing value="api">
          <template #actions>
            <ButtonComponent
              :label="$t('activate')"
              :icon="['fal', 'plus']"
              theme="primary"
              :labels="{ confirm: $t('confirm') }"
              :icons="{ confirm: ['fas', 'question-circle'] }"
              confirm
              @click="addon"
              :promise="addonPromise"
            />
          </template>
        </Pricing>
      </template>
      <template #default>
        <Card class="settings-webhooks">
          <template #default>
            <DataTable
              :value="items"
              theme="border"
              :columns="[
                { id: 'status', label: $t('status') },
                { id: 'name', label: $t('name') },
                { id: 'url', label: $t('url'), size: '1fr' },
              ]"
              :row-wrapper="
                item => ({
                  component: 'router-link',
                  props: { to: { name: 'webhook-edit', params: { id: item.id } }, style: 'color: inherit' },
                })
              "
            >
              <template #status="{ item }">
                <FontAwesomeIcon
                  :icon="['fas', item.enabled ? 'play-circle' : 'pause-circle']"
                  :class="{ 'text--success': item.enabled, 'text--warning': !item.enabled }"
                />
              </template>
              <template #name="{ item }">
                <span>{{ item.name }}</span>
                <FontAwesomeIcon v-if="item.isSystem" :icon="['fal', 'cog']" size="sm" class="ml-1" />
              </template>
              <template #url="{ item }">{{ item.url }}</template>
              <template #primary-row-actions="{ item }">
                <ButtonComponent
                  tag="router-link"
                  :to="{ name: 'webhook-edit', params: { id: item.id } }"
                  v-tooltip="$t('edit')"
                  :icon="['fal', 'pen']"
                />
              </template>
            </DataTable>
            <EmptyState
              v-if="!items.length && !errors.fetch"
              :icon="['fal', 'bolt']"
              :title="$t('noX', { x: $tc('webhook', 2) })"
            />
          </template>
          <template #footer>
            <ButtonComponent
              tag="router-link"
              :to="{ name: 'webhook-create' }"
              :label="$t('create')"
              :icon="['fal', 'plus']"
              theme="primary"
            />
          </template>
        </Card>
      </template>
    </Paywall>
  </Loader>
</template>

<script>
import { i18n } from '@/i18n'
import Store from '@/store'
import { mapState, mapActions } from 'vuex'

import Card from '@/components/Card'
import { Paywall } from '@/components/Upsell'
import Pricing from '@/components/Pricing'
import EmptyState from '@/components/EmptyState'
import DataTable from '@/components/DataTable'

const meta = {
  skip: !Store.getters.isDeveloper,
  order: 3,
  id: 'webhooks',
  label: i18n.tc('webhook', 2),
  icon: ['fal', 'redo'],
}

export { meta }
export default {
  props: {
    isActive: Boolean,
  },
  watch: {
    isActive: {
      handler(val) {
        if (!val) return
        return this.fetch()
      },
      immediate: true,
    },
  },
  data() {
    return {
      addonPromise: null,
    }
  },
  computed: {
    ...mapState('Webhook', ['items', 'promises', 'errors']),
  },
  methods: {
    ...mapActions('Webhook', ['fetch']),
    addon() {
      return (this.addonPromise = this.$store.dispatch('subscription', { item: 'api', state: true }))
    },
  },
  components: {
    Card,
    Paywall,
    Pricing,
    EmptyState,
    DataTable,
  },
}
</script>
